/*
  SEE AUTH DOCO AT https://github.com/cirruscomms/atmos/wiki/Authentication
*/

import API from './apiHelper'

const authRoot = process.env.VUE_APP_AUTH_ROOT

export const login = (username, password) => {
  // If successful, returns object with access & refresh tokens.
  // If unsuccessful, returns object with error, error_description & message.
  return API.post(`${authRoot}/login`, {
    data: { username, password }
  })
}

export const refresh = refresh_token => {
  // If successful, returns object with new access & refresh tokens.
  // If unsuccessful, returns object with error, error_description, hint & message.
  return API.post(`${authRoot}/refresh`, { data: { refresh_token } })
}

export const forgot = email => {
  // If successful, returns TODO: needs to be tested
  // If unsuccessful, returns TODO: needs to be tested
  return API.post(`${authRoot}/forgot`, { data: { email } })
}

export const reset = (email, password, password_confirmation, token) => {
  // If successful, returns TODO: needs to be tested
  // If unsuccessful, returns TODO: needs to be tested
  return API.post(`${authRoot}/reset`, {
    data: { email, password, password_confirmation, token }
  })
}

export const masquerade = user_id => {
  // If successful, returns object with new access & refresh tokens.
  // If unsuccessful, returns object with error, error_description, hint & message.
  return API.post(`${authRoot}/masquerade`, { data: { user_id } })
}

export const logout = () => {
  return API.post(`${authRoot}/logout`)
}
